import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import map from 'lodash/map'
import find from 'lodash/find'
import filter from 'lodash/filter'
import classnames from 'classnames'
import RemoveFile from '@Images/upload_remove_file.svg'
import getFormattedDuration from '@Utils/GetFormattedDuration'

import {
  IProject,
} from '@SiteModules/Project/types'

import {
  setEditingProjectIds,
} from '@SiteModules/Popup/actions'

import './SelectedProjectsTable.scss'

interface SelectedProjectsProps {
  readonly editingProjects: IProject[]
  readonly editingProjectIds: string[]
  closePopup(): void
}

const SelectedProjectsTable: React.FC<SelectedProjectsProps> = props => {
  const dispatch = useDispatch()

  const {
    editingProjectIds,
    editingProjects,
  } = props

  useEffect(() => {
    if (editingProjectIds.length === 0) {
      props.closePopup()
    }
  }, [editingProjectIds])

  const tableRows = map(editingProjects, (project, index) => {
    const {
      id,
      attributes,
      projectVersions,
    } = project

    const {
      title,
    } = attributes

    const originalProjectVersion = find(projectVersions, projectVersion => projectVersion.attributes.isRepurposed)
    const duration = originalProjectVersion?.attributes.duration
    const numberOfProjectVersions = projectVersions.length
    const numberOfClips =Math.max(numberOfProjectVersions - 1, 0)
    const numberOfLanguages = originalProjectVersion?.subtitles.length || 0

    const handleRemove = () => {
      const updatedEditingProjectIds = filter(editingProjectIds, editingProjectId => editingProjectId !== id)
      dispatch(setEditingProjectIds({ updatedEditingProjectIds }))
    }

    return (
      <tr
        className={classnames(
          { 'SelectedProjectsTable__row-even': index % 2 === 0 },
          { 'SelectedProjectsTable__row-uneven': index % 2 === 1 }
        )}
        key={index}
      >
        <td className="SelectedProjectsTable__title">
          <div className="SelectedProjectsTable__title-text">
            {title}
          </div>
        </td>
        <td className="SelectedProjectsTable__duration">
          {typeof(duration) === 'string' && getFormattedDuration(duration)}
        </td>
        <td className="SelectedProjectsTable__clips">
          {numberOfClips}
        </td>
        <td className="SelectedProjectsTable__languages">
          {numberOfLanguages}
        </td>
        <td className="SelectedProjectsTable__remove">
          <RemoveFile
            onClick={handleRemove}
          />
        </td>
      </tr>
    )
  })

  const renderTableHeader = () => {
    return (
      <tr>
        <th className="SelectedProjectsTable__title">
          Title
        </th>
        <th className="SelectedProjectsTable__duration">
          Duration
        </th>
        <th className="SelectedProjectsTable__clips">
          Clips
        </th>
        <th className="SelectedProjectsTable__languages">
          Languages
        </th>
        <th className="SelectedProjectsTable__remove"/>
      </tr>
    )
  }

  return (
    <div className="SelectedProjectsTable">
      <table>
        <thead>
          {renderTableHeader()}
        </thead>
        <tbody className="SelectedProjectsTable__body">
          {tableRows}
        </tbody>
      </table>
    </div>
  )
}

export default SelectedProjectsTable
